import * as types from './actionTypes';
import { hideModal } from './modalActions';

export function setLoading(appIsLoading, hideModalFlag = true) {
  return dispatch => {
    if (hideModalFlag) {
      dispatch(hideModal());
    }
    dispatch({
      type: types.APP_IS_LOADING,
      appIsLoading,
    });
  };
}
